import isObject from '#shared/util/isObject.js';

import cLogo from '#themes/default/default/components/logo/logo.js';
import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './topHeader.html' with { type: 'html' };

export default {
	name: 'CTopHeader',
	components: {
		cLogo,
		cSvg
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		theme: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showSignIn: false // @todo replace by real condition
		};
	},
	computed: {
		brand() {
			return isObject(this.theme) ? this.theme.brand : '';
		}
	},
	template
};
